import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'shared/Redux/slices';

const getAuth = (state: RootState) => state.auth;

export default createSelector([getAuth], auth => auth.user);
